const GlassDesignerConfig = {

  Settings: {
    orderEditorDataVersion: 1,
    
    arcSubdivisions: 20,
    libraryThumbnailSize: 60,
    centerCutoutMaxSnapDistance: 5
  },

  // Note: Don't access directly
  // Access via GlassEditor.settings.theme object as that contains the current theme
  Theme: {
    light: {
      background: '#f4f4f4',
      gridAxisColour: '#7070A0',
      gridMajorColour: '#a7a7a7',
      gridMinorColour: '#d7d7d7',
      gridLineOpacity: 0.3,
      panelColour: '#DCEEF6',
      panelLightingColour: '#808080',
      panelCancelledColour: '#FF9090',
      panelLockedColour: '#808080',
      panelOutlineColour: '#000000',
      panelOutlineOpacity: 0.25,
      panelHighlightColour: '#FF0000',
      panelHighlightOpacity: 0.7,
      panelPolishedColour: '#3030D7',
      panelPolishedOpacity: 1.0,
      panelPolishedWidth: 1.0,
      selectionColour: '#FF0000',
      selectionWidth: 2.0,
      selectionBoxOutlineColour: '#202040',
      selectionBoxOutlineOpacity: 0.3,
      selectionBoxColour: '#a0a0a0',
      selectionBoxOpacity: 0.075,
      datumLineColour: '#000080',
      splitLineColour: '#0000FF',
      splitLineDisplayCircleColour: '#0000FF',
      splitLineDisplayCircleOpacity: 0.75,
      splitLineDisplayCircleLabelColour: '#FFFFFF',
      groupColour: '#008700',
      groupPolishedColour: '#3030D7',
      shapeBoundaryColour: '#a0a0a0',
      shapeBoundaryLabelColour: '#ffffff',
      assemblyColour: '#D730D7',
      dragObjectColour: '#000000',
      dragObjectOpacity: 0.5,
      counterSunkColour: '#FF00FF',
      counterSunkAlpha: 0.75,
      editingOutlineColour: '#000000',
      editingOutlineOpacity: 0.5,
      editingLineColour: '#0085F3',
      editingLineTextColour: '#606070',
      editingDashLineColour: '#000000',
      dimExtLineColour: '#808080',
      dimArrowColour: '#404040',
      dimLineColour: '#404040',
      dimArrowOpacity: 0.25,
      dimLineOpacity: 0.35,
      dimLabelColour: '#505060',
      dimLabelHighlightColour: '#000070',
      dimFixedLabelColour: '#970000',
      dimReadOnlyOpacity: 0.5,
      dimErrorColour: '#FF0000',
      dimErrorOpacity: 1.0,
      dimOverallActiveColour: '#4040FF',
      dimOverallActiveOpacity: 1.0,
      dimSquareColour: '#404040',
      dimSquareOpacity: 0.5,
      dimFixedSquareColour: '#970000',
      cuttingPlaneColour: '#000000',
      cuttingPlaneOpacity: 1.0,
      cuttingShapeOutlineColour: '#FF0000',
      cuttingShapeOutlineOpacity: 0.5,
      cutoutCenterPolishedColour: '#3030D7',
      cutoutCenterPolishedOpacity: 0.8,
      cutoutCenterDatumColour: '#008000',
      cutoutCenterDatumOpacity: 0.75,
      cutoutShapePolishedColour: '#3030D7',
      cutoutShapePolishedOpacity: 0.8,
      rulerBackground: '#ffffff',
      rulerTickColour: '#606060',
      rulerLabelColour: '#202020',
      rulerMouseColour: '#40ef40',
      reviewHighlightColour: '#ff4000',
      reviewHighlightRegionOpacity: 0.15
    },
    dark: {
      background: '#101010',
      gridAxisColour: '#00FF00',
      gridMajorColour: '#A7A7A7',
      gridMinorColour: '#878787',
      gridLineOpacity: 0.25,
      panelColour: '#4C6E86',
      panelLightingColour: '#808080',
      panelCancelledColour: '#FF8080',
      panelLockedColour: '#808080',
      panelOutlineColour: '#000000',
      panelOutlineOpacity: 0.25,
      panelHighlightColour: '#FF0000',
      panelHighlightOpacity: 0.7,
      panelPolishedColour: '#00FFFF',
      panelPolishedOpacity: 1.0,
      panelPolishedWidth: 1.0,
      selectionColour: '#FF0000',
      selectionWidth: 2.0,
      selectionBoxOutlineColour: '#A0A0A0',
      selectionBoxOutlineOpacity: 0.6,
      selectionBoxColour: '#a0a0a0',
      selectionBoxOpacity: 0.1,
      datumLineColour: '#000080',
      splitLineColour: '#00FFFF',
      splitLineDisplayCircleColour: '#00FFFF',
      splitLineDisplayCircleOpacity: 0.85,
      splitLineDisplayCircleLabelColour: '#000000',
      groupColour: '#FFFF00',
      groupPolishedColour: '#00FFFF',
      assemblyColour: '#D730D7',
      dragObjectColour: '#FFFFFF',
      dragObjectOpacity: 0.75,
      counterSunkColour: '#FF00FF',
      counterSunkAlpha: 0.75,
      editingOutlineColour: '#FFFFFF',
      editingOutlineOpacity: 0.75,
      editingLineColour: '#0085F3',
      editingLineTextColour: '#FFFFFF',
      editingDashLineColour: '#FFFF00',
      dimExtLineColour: '#B0B0B0',
      dimArrowColour: '#F7F7F7',
      dimLineColour: '#F7F7F7',
      dimArrowOpacity: 0.25,
      dimLineOpacity: 0.35,
      dimLabelColour: '#E0E0E0',
      dimLabelHighlightColour: '#00FFFF',
      dimFixedLabelColour: '#FF4040',
      dimReadOnlyOpacity: 0.5,
      dimErrorColour: '#FF0000',
      dimErrorOpacity: 1.0,
      dimOverallActiveColour: '#8080FF',
      dimOverallActiveOpacity: 1.0,
      dimSquareColour: '#F7F7F7',
      dimSquareOpacity: 0.5,
      dimFixedSquareColour: '#FF4040',
      cuttingPlaneColour: '#FFFFFF',
      cuttingPlaneOpacity: 1.0,
      cuttingShapeOutlineColour: '#FF0000',
      cuttingShapeOutlineOpacity: 0.75,
      cutoutCenterPolishedColour: '#00FFFF',
      cutoutCenterPolishedOpacity: 0.8,
      cutoutCenterDatumColour: '#00FF00',
      cutoutCenterDatumOpacity: 0.75,
      cutoutShapePolishedColour: '#00FFFF',
      cutoutShapePolishedOpacity: 0.8,
      rulerBackground: '#1E1E1E',
      rulerTickColour: '#505050',
      rulerLabelColour: '#A0A0A0',
      rulerMouseColour: '#40ef40',
      reviewHighlightColour: '#ff4000',
      reviewHighlightRegionOpacity: 0.15
    }
  },

  Mouse: {
    buttonSelect: 0,      // Left
    buttonMiddle: 1,      // Wheel
    buttonPan: 2,         // Right
    wheelZoomFactor: 120,
    dragZoomFactor: 10
  },

  Zooming: {
    minZoom: 0.075,
    maxZoom: 15,
    zoomStepCount: 100
  },

  SVGStyles: {
    glassPieceColour: '#BDDFEA',
    glassEdgeColour: '#1C4755',
    glassEdgeWidth: '1',
    edgeworkWidth: '4',
    glassGridColour: '#b0b0b0',
    glassGridOpacity: '0.20',
    glassBorderColour: '#d0d0d0',
    dimensionColour: '#000000',
    dimensionFontSize: '9px',
    angleMarkerColour: '#000000',
    angleMarkerOpacity: '0.25',
    legendBorderColour: '#606060',
    legendTitleFontSize: '10px',
    legendFontSize: '8px',
    viewTitleFontSize: '12px',
    holeAnchorColour: '#008000',
    holeAnchorWidth: 1,
    headerFillColour: '#e0e0e0',
    summaryDotColour: '#000000'
  }
}

module.exports = GlassDesignerConfig